var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'd-flex align-items-center': _vm.dot
  }},[_c('div',{class:[
      _vm.bg,
      {
        border: _vm.withBorder,
        'balloon-container rounded-circle mr-2 w-unset': _vm.dot,
        'w-100 rounded-pill font-weight-bold': !_vm.dot
      }
    ],style:(_vm.hexColor ? _vm.hexColorStyle : '')},[_c('div',{staticClass:"d-flex align-items-center",class:{
        'justify-content-center': _vm.withBorder,
        'p-03': _vm.dot,
        'p-2': !_vm.dot
      }},[(_vm.icon)?_c('em',{staticClass:"fa-xs mr-2",class:_vm.icon}):_vm._e(),(!_vm.dot)?_c('span',{class:_vm.color,style:('color:' + _vm.hexTextColor)},[_vm._v(_vm._s(_vm.text))]):_vm._e()])]),(_vm.dot)?_c('span',{staticClass:"font-weight-bold",class:_vm.color},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }